<template>
  <div class="reserve-calendar-modal" @click="emitClose()">
    <div @click="emitClose()" class="close-modal-btn">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.450235 0.415845C1.03879 -0.149848 1.97977 -0.136746 2.55198 0.44511L8 5.98501L13.448 0.44511C14.0202 -0.136746 14.9612 -0.149848 15.5498 0.415845C16.1383 0.981538 16.1516 1.91181 15.5794 2.49367L10.1644 8L15.5794 13.5063C16.1516 14.0882 16.1383 15.0185 15.5498 15.5842C14.9612 16.1498 14.0202 16.1367 13.448 15.5549L8 10.015L2.55198 15.5549C1.97977 16.1367 1.03879 16.1498 0.450235 15.5842C-0.13832 15.0185 -0.151573 14.0882 0.420633 13.5063L5.83565 8L0.420633 2.49367C-0.151573 1.91181 -0.13832 0.981538 0.450235 0.415845Z"
          fill="#EDEDED"
        />
      </svg>
    </div>
    <ReservationCard class="reserve-card" :reservation="reservation" />
  </div>
</template>
<script>
import ReservationCard from "@/components/notifications/ReservationCard.vue";

export default {
  props: ["reservation"],
  components: { ReservationCard },
  methods: {
    emitClose() {
      this.$emit("onCloseModal");
    },
  },
};
</script>
<style >
.reserve-calendar-modal {
  position: fixed;
  z-index: 100;
  top: 7.7vh;
  left: 0;
  min-width: 100%;
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
}
.reserve-card {
  margin-top: 14.778325123152708vh;
}
.close-modal-btn {
  position: absolute;
  top: 2.463054187192118vh;
  right: 2.463054187192118vh;
  width: 4.926108374384236vh;
  height: 4.926108374384236vh;
  background: rgba(70, 70, 70, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.close-modal-btn svg {
  width: 1.9704433497536944vh;
  height: 1.9704433497536944vh;
}
@media screen and (min-width: 765px) {
  .reserve-calendar-modal {
    top: 4.167vw;
  }
}
</style>